import { isMeetingConfirmed } from 'common-data-handling';
import moment from 'moment';
import React from 'react';
import { DATE_FORMAT_URL } from '../../../../../../data/constants/datetime';
import { isMeetingCreatedByUser } from '../../../../../../data/filters/meetings/isMeetingCreatedByUser/isMeetingCreatedByUser';
import { isMeetingUnconfirmed } from '../../../../../../data/filters/meetings/isMeetingUnconfirmed';
import { useEventSettings } from '../../../../../../data/hooks/events/useEventSettings';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import { useMeetings } from '../../../../../../data/hooks/meeting/useMeetings';
import { useMyUserId } from '../../../../../../data/hooks/sessionHooks';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';

function StepConfirmMeetings(props) {
    const { eventId } = props,
        i18n = useI18n(),
        settings = useEventSettings(eventId),
        visible = !settings.disable_meetings,
        selfUserId = useMyUserId(),
        meetings = useMeetings(eventId, {
            // filter: overEvery([negate(isMeetingCreatedByUser.bind(null, selfUserId)), isMeetingUnconfirmed]),
            filter: meeting => !isMeetingCreatedByUser(selfUserId, meeting) && isMeetingUnconfirmed(meeting),
        }),
        confirmedMeetings = useMeetings(eventId, {
            filter: isMeetingConfirmed,
        });

    // console.log('DBG', meetings, confirmedMeetings);

    return (
        <StartNetworkingStep
            href={['/events', eventId, 'meetings', moment(meetings[0]?.start_local).format(DATE_FORMAT_URL)].join('/')}
            visible={visible}
            enabled={meetings.length > 0}
            complete={confirmedMeetings.length > 0}
            disabledHint={i18n['start.confirm_meetings.disabled']}>
            {i18n['start.confirm_meetings']}
        </StartNetworkingStep>
    );
}

export default StepConfirmMeetings;
